import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Form } from "react-bootstrap";
import { useFormikContext } from "formik";
import { useAppDispatch } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { genNewReceiptDocNumber } from "../redux/slices/logic/genNewReceiptDocNumber.slice";
var TaxReceiptSwitch = function(param) {
    var setFormdata = param.setFormdata;
    var dispatch = useAppDispatch();
    var values = useFormikContext().values;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var handleChange = function(e) {
        var checked = e.target.checked;
        setFormdata(_object_spread_props(_object_spread({}, values), {
            is_tax_receipt: checked
        }));
        dispatch(genNewReceiptDocNumber({
            modalObj: modalObj,
            setModalObj: setModalObj,
            queryParams: {
                isTaxReceipt: checked
            }
        }));
    };
    return /*#__PURE__*/ _jsx(Form.Check, {
        type: "switch",
        id: "custom-switch",
        label: "",
        name: "is_tax_receipt",
        className: "custom-switch-st-1 mt-1",
        onChange: handleChange,
        checked: values.is_tax_receipt,
        disabled: values.fact_new_invoice_id
    });
};
export default TaxReceiptSwitch;
